import React from 'react'
import ProductComp from './Components/ProductComp/ProductComp'
import { Typography,
    Grid  } from '@material-ui/core';
import { makeStyles, useTheme  } from '@material-ui/styles';


const products=[
    {
        name:"Adobe InDesign",
        info:"Adobe InDesign is the industry-leading page design and layout app that has everything you need to craft elegant layouts for print and digital media",
        release:"2020 version 3.0",
        logo:"/images/prod-logos/logo1.jpg" 
    },
    {
        name:"Word Home and Student",
        info:"For 1 PC or Mac Create beautiful and engaging documents Compatible with Windows 10 or macOS All languages included For non-commercial use",
        release:"2019 version 2.0",
        logo:"/images/prod-logos/logo3.jpg" 
    },
    {
        name:"AutoCAD LT",
        info:"AutoCAD LT 2D drafting software helps you create, share, and document your 2D drawings in DWG and other file formats, AutoCAD LT",
        release:"2020 version 3.0",
        logo:"/images/prod-logos/logo4.jpg" 
    },
    {
        name:"Adobe Creative Cloud",
        info:"Adobe Creative Cloud is the premiere creative software package and includes over 20 creative apps for desktop and mobile devices",
        release:"2019 version 2.0",
        logo:"/images/prod-logos/logo2.jpg" 
    },
    {
        name:"Adobe Photoshop",
        info:"Get Photoshop, the industry standard for photo and design software. There have been hundreds of updates since Photoshop CS6. Get free product updates",
        release:"2020 version 3.0",
        logo:"/images/prod-logos/logo5.jpg" 
    },
    {
        name:"Adobe Audition",
        info:"Adobe Audition | Audio Recording, Editing, And Mixing Software |1-month Subscription With Auto-renewal | Audio Recording, Editing",
        release:"2019 version 2.0",
        logo:"/images/prod-logos/logo6.jpg" 
    },
]
const useStyles = makeStyles(theme => ({
    
    root: {
     display:'flex',
     flexDirection: 'column',
     flex:1
    },
    gridContainerOuter:{
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner:{
        padding : '6px 6px',
        width: '100%'
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
}));
export default function Products() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleDiv}>
                <Typography variant="h2">Products</Typography>
            </div>
            <Grid container className={classes.gridContainerOuter}>
                {
                    products.map(product=>(
                        <Grid item xs={12} sm={6} md={4}  key={product.name} className={classes.gridItemInner}>
                            <ProductComp 
                            name={product.name}
                            info={product.info}
                            release={product.release}
                            logo={product.logo} 
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </div>
    )
}
